export default __webpack_public_path__ + "static/media/2.2cb7a177.png";